import { useEffect, useState } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import CommonProvider from '../../../context/CommonContext';
import CurrencyProvider from '../../../context/CurrencyContext';
import LocaleProvider from '../../../context/LocaleContext';
import { CustomerConfigI } from '../../../declarations/interfaces/customer';
import ScrollToTop from '../../ScrollTop/ScrollTop';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Hero from '../Hero/Hero';

type RootLayoutPropsT = {
  config: CustomerConfigI;
};

const RootLayout: React.FC<RootLayoutPropsT> = ({ config }) => {
  const { headerData, footerData, logoUrl, linkFromLogo, heroImageUrl, slugUrl } = config;

  const location = useLocation();
  const [isIframe, setIsIframe] = useState(false);

  function sendHeightToParent() {
    // Determine the desired height of the iframe content
    const desiredHeight = document.getElementById('root')?.scrollHeight;
    // Send the desired height to the parent component
    window.parent.postMessage({ type: 'setHeight', height: desiredHeight }, '*');
  }

  useEffect(() => {
    if (window.self !== window.top) {
      setIsIframe(true);
    } else {
      setIsIframe(false);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      sendHeightToParent();
    }, 1000);
  }, [location]);

  return (
    <CommonProvider value={config}>
      <LocaleProvider>
        <CurrencyProvider>
          <ScrollToTop />

          {!isIframe && (
            <Header data={headerData} logoLink={linkFromLogo} logoSrc={logoUrl} slugUrl={slugUrl} />
          )}
          <Hero imageUrl={heroImageUrl} />
          <Outlet />
          <Footer data={footerData} slugUrl={slugUrl} isIframe={isIframe} />
        </CurrencyProvider>

        <ScrollRestoration />
      </LocaleProvider>
    </CommonProvider>
  );
};

export default RootLayout;
